/** @format */
import React from 'react';
import { Grid, Typography } from '@mui/material';
import { useStyles } from './style';
const UpgradeInstruction = ({
  bizTypeCode = null,
  isActive = false,
  bizOwnerLevel = 0, // number
}) => {
  const classes = useStyles();
  const linkToHelp = 'https://podium.ir/register/rules';

  return (
    <Grid item xs={12}>
      {isActive ? (
        <>
          {!bizTypeCode ? <Typography className={classes.cardBody} color="textSecondary" /> : null}
          {bizTypeCode === 'BUSINESS_TYPE_HOMEMADE' ? (
            <Typography className={classes.cardBody} color="textSecondary">
              در صورتی‌که کسب‌وکار شما حقیقی است، برای تایید کسب‌وکار خود لازم است کپی کارت ملی مالک
              کسب‌وکار خود را بارگذاری نمایید. تایید کسب‌وکار توسط کارشناسان پادیوم انجام می‌شود.
            </Typography>
          ) : null}
          {bizTypeCode === 'BUSINESS_TYPE_PERSONAL_WITH_ECONOMIC_CODE' ? (
            <Typography className={classes.cardBody} color="textSecondary">
              همچنین در صورتیکه کسب‌وکار شما دارای کد اقتصادی است با درج آن می‌توانید از سطوح مالی
              درج شده در
              <a href={linkToHelp}>{' جدول شماره ۳ قوانین کسب‌وکار '}</a>
              بهره‌مند شوید.
            </Typography>
          ) : null}
          {bizTypeCode === 'BUSINESS_TYPE_PERSONAL_WITHOUT_ECONOMIC_CODE' ||
          bizTypeCode === 'BUSINESS_TYPE_PERSONAL_WITH_ECONOMIC_CODE' ? (
            <>
              {bizOwnerLevel < 1 ? (
                <Typography className={classes.cardBody} color="textSecondary">
                  برای ارتقا کسب‌وکار خود به سطح یک، پس از درج شماره موبایل مالک کسب وکار، یک کد
                  برای شماره درج شده ارسال می‌شود که پس از وارد کردن کد ارسال شده و تطابق آن،
                  کسب‌وکار به سطح یک ارتقا می‌یابد. سقف‌های مالی که هر سطح کسب‌وکار می‌تواند مطابق
                  آن‌ها، عملیات مالی خود را انجام دهد ، در
                  <a href={linkToHelp}>{' اینجا '}</a>
                  قابل مشاهده است.
                </Typography>
              ) : null}
              {bizOwnerLevel == 1 ? (
                <Typography className={classes.cardBody} color="textSecondary">
                  برای ارتقا کسب‌وکار خود به سطح دو لازم است کدملی مالک کسب‌وکار خود را درج نمایید.
                  در صورتیکه کدملی درج شده با نام شخصی که شماره موبایل درج شده به نام وی است، مطابقت
                  داشته باشد، کسب‌وکار به سطح دو ارتقا می‌یابد. سقف‌های مالی که هر سطح کسب‌وکار
                  می‌تواند مطابق آن‌ها، عملیات مالی خود را انجام دهد، در
                  <a href={linkToHelp}>{' اینجا '}</a>
                  قابل مشاهده است.
                </Typography>
              ) : null}
              {bizOwnerLevel == 2 ? (
                <Typography className={classes.cardBody} color="textSecondary">
                  برای ارتقا کسب‌وکار خود به سطح سه لازم است صحت اطلاعات هویتی درج شده شامل تاریخ
                  تولد احراز شود. سقف‌های مالی که هر سطح کسب‌وکار می‌تواند مطابق آن‌ها، عملیات مالی
                  خود را انجام دهد ، در
                  <a href={linkToHelp}>{' اینجا '}</a>
                  قابل مشاهده است.
                </Typography>
              ) : null}
              {bizOwnerLevel == 3 ? (
                <Typography className={classes.cardBody} color="textSecondary">
                  برای ارتقا کسب‌وکار خود به سطح چهار لازم است فیلم چهره ارسالی با تصویر کارت ملی
                  مطابقت داشته باشد. برای ارسال فیلم چهره خود لازم است
                  <a href="https://www.wepod.ir/">{' اپلیکیشن ویپاد را نصب کنید '}</a>. سقف‌های مالی
                  که هر سطح کسب‌وکار می‌تواند مطابق آن‌ها، عملیات مالی خود را انجام دهد، در
                  <a href={linkToHelp}>{' اینجا '}</a>
                  قابل مشاهده است.
                </Typography>
              ) : null}
              {bizOwnerLevel == 4 ? (
                <Typography className={classes.cardBody} color="textSecondary">
                  برای ارتقا کسب‌وکار خود به سطح پنج لازم است مالک کسب‌وکار با حضور در یکی از
                  شعبه‌های بانک پاسارگاد، احراز هویت حضوری شود. سقف‌های مالی که هر سطح کسب‌وکار
                  می‌تواند مطابق آن‌ها، عملیات مالی خود را انجام دهد ، در
                  <a href={linkToHelp}>{' اینجا '}</a>
                  قابل مشاهده است.
                </Typography>
              ) : null}
            </>
          ) : null}
          {bizTypeCode === 'BUSINESS_TYPE_LEGAL_WITHOUT_ECONOMIC_CODE' ? (
            <Typography className={classes.cardBody} color="textSecondary">
              در صورتیکه کد اقتصادی برای کسب‌وکار خود دریافت کرده‌اید، با درج آن می‌توانید از سطوح
              مالی درج شده در
              <a href={linkToHelp}>{' جدول شماره ۴ قوانین کسب‌وکار '}</a>
              بهره‌مند شوید.
            </Typography>
          ) : null}
        </>
      ) : (
        <Typography className={classes.cardBody} color="textSecondary">
          در صورتی‌که کسب وکار شما حقیقی است، برای تایید کسب‌وکار خود لازم است کپی کارت ملی مالک
          کسب‌وکار خود را بارگذاری نمایید. تایید کسب‌وکار توسط کارشناسان پادیوم انجام می‌شود.
          <br />
          برای تایید کسب‌وکار حقوقی می‌توانید مدارک شرکت ثبت شده خود را شامل اساسنامه و روزنامه
          رسمی، ارسال نمایید تا پس از صحت‌سنجی آن، شرکت شما به وضعیت تایید شده در بیاید.
        </Typography>
      )}
    </Grid>
  );
};

export default UpgradeInstruction;
